var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pdfViewer"}},[_c('div',{staticClass:"pdfMasker"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('i',{staticClass:"close",on:{"click":function($event){return _vm.close()}}}),_vm._v(" "),_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,attrs:{"src":_vm.url,"page":i}})})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20cb9ef9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pdfView.vue
// module id = null
// module chunks = 